// "Trans Mgmt" tab of the WM Transaction Management Data Profile form — Delphi tabBottomAdditional.
//
// Three group boxes: the two transaction-tab codes, the seven other tab visibility flags, and the
// uninvoiced-charges flag. grpAdditionalRight is an empty alClient spacer in the DFM and has no web
// equivalent.
//
// Default Tab's option list is narrowed at runtime from the current Visible Tabs value, which is the
// whole of uWMD0081.PAS SetDefaultTab; see CodeLists.defaultTabOptionsFor.
import { TABLE_NAME } from "./CodeLists";

const yesNo = (name, label) => ({
    name,
    tableName: TABLE_NAME,
    label,
    type: "select",
    required: false,
    visible: true,
    isLabelChanged: false,
});

export const TransMgmtTabLayout = [
    {
        "groupId": 1,
        "label": "Top Tabs - Transactions",
        "fields": [
            {
                "name": "TabDefaults",
                "tableName": TABLE_NAME,
                "label": "Visible Tabs",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TransTabDefaults",
                "tableName": TABLE_NAME,
                "label": "Default Tab",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ],
    },
    {
        "groupId": 2,
        "label": "Top Tabs - Other",
        "fields": [
            yesNo("EdiOrdersTab", "EDI Tab"),
            yesNo("WebOrdersTab", "Web Tab"),
            yesNo("CustomersTab", "Customer Tab"),
            yesNo("ItemTab", "Item Tab"),
            yesNo("LotTab", "Lot Tab"),
            yesNo("SubLotTab", "Sublot Tab"),
            yesNo("LocationTab", "Location Tab"),
        ],
    },
    {
        "groupId": 3,
        "label": "Top Tabs - UnInvoiced Charges",
        "fields": [
            yesNo("UninvoicedChargesTab", "Un Inv Tab"),
        ],
    },
];
